import { OwnUserResponse, UserResponse } from "stream-chat";
import { useChatContext } from "stream-chat-react";

type CurrentStreamUser = {
  user: OwnUserResponse | UserResponse | undefined;
  userId: string | undefined;
};

export const useCurrentStreamUser = (): CurrentStreamUser => {
  const { client } = useChatContext();

  return { user: client.user, userId: client.userID };
};
